import React from 'react'
import { IGridHeaderOption, IModalObject } from '.'
import { Button } from '@mui/material'
import GenerateIcon from '../GenerateIcon'
import { useReturnCurrentUser } from '../../features/user/userSlice'

interface IProps {
    options: IGridHeaderOption[],
    updateFilterShowStatus: (status: boolean) => void,
    deleteItem: (id: number) => void,
    deleteManyItems: (items: number[]) => void,
    refresh: () => void,
    selectedItems: IModalObject,
    enableFilter?: boolean,
    filterShownStatus?: boolean,
    disableDelete?: boolean,
}

interface IGridDataOptionProps extends IGridHeaderOption{
    updateFilterShowStatus: (status: boolean) => void,
    deleteItem: (id: number) => void,
    deleteManyItems: (items: number[]) => void,
    refresh: () => void,
    selectedItems: IModalObject,
    filterShownStatus?: boolean,
}

export function GridDataOption(props: IGridDataOptionProps){

    const { label, icon, onClick, customButton, color, selectedItems, deleteItem, deleteManyItems, refresh, updateFilterShowStatus, filterShownStatus, disabled } = props

    if (customButton){
        return customButton(selectedItems, updateFilterShowStatus, deleteItem, deleteManyItems, refresh, filterShownStatus)
    }

    return <Button disabled={disabled} className="general-button admin-button" color={color} startIcon={<GenerateIcon icon={icon} />} onClick={() => onClick()}>{label}</Button>
}

/**
 * Options
 */
export default function GridDataOptions(props: IProps) {

    const { updateFilterShowStatus, deleteItem, deleteManyItems, refresh, enableFilter, selectedItems, filterShownStatus, disableDelete } = props
    
    let options: IGridHeaderOption[] = []

    let defaultOptions: IGridHeaderOption[] = []

    const currentUser = useReturnCurrentUser()

    if (!disableDelete){
        defaultOptions.push({
            label: "Delete",
            icon: "delete",
            onClick: () => {},
            customButton: (selectedItems, updateFilterShowStatus, deleteItem, deleteManyItems, refresh)  =>{
                
                const handleDelete = () => {
                    let ids: number[] = []
                    selectedItems.map((item: IModalObject) => ids.push(item.id))
                    deleteManyItems(ids, false)
                }
                
                return <Button disabled={selectedItems.length > 0 ? false : true} className="general-button admin-button" color="error" onClick={() => handleDelete()}>Delete ({selectedItems.length})</Button>
            },
        })

        // if (currentUser.is_daemon){
        //     defaultOptions.push({
        //         label: "Permanently Delete",
        //         icon: "delete",
        //         onClick: () => {},
        //         customButton: (selectedItems, updateFilterShowStatus, deleteItem, deleteManyItems, refresh)  =>{
                    
        //             const handleDelete = () => {
        //                 let ids: number[] = []
        //                 selectedItems.map((item: IModalObject) => ids.push(item.id))
        //                 deleteManyItems(ids, true)
        //             }
                    
        //             return <Button disabled={selectedItems.length > 0 ? false : true} className="general-button admin-button" color="error" onClick={() => handleDelete()}>Permanently Delete ({selectedItems.length})</Button>
        //         },
        //     })
        // }
    }

    defaultOptions.push({
        label: "Refresh",
        icon: "refresh",
        onClick: () => refresh(),
    })

    if (enableFilter){
        defaultOptions.push({
            label: "Filter",
            icon: "filter",
            onClick: () => updateFilterShowStatus(filterShownStatus ? false : true),
        })
    }

    options = [
        ...defaultOptions,
        ...props.options
    ]

    return(
        <div className="grid-data-options-header">
            <div className="content-of-grid-data-options-header">
                {options.map((option, index: number) => <GridDataOption {...option} key={index} updateFilterShowStatus={updateFilterShowStatus} selectedItems={selectedItems} deleteItem={deleteItem} deleteManyItems={deleteManyItems} refresh={refresh} />)}
            </div>
        </div>
    )
}